{
  "clear": "Очистити",
  "invalid": "(недійсне)",
  "loading": "Завантаження...",
  "noResults": "Результатів немає"
}
